import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';
import { Ref } from 'vue';

export function useContraAccountData(companyId: Ref<number>) {
    const {
        data: contraAccounts,
        isPending: loadingContraAccounts,
        refetch: fetchContraAccounts,
    } = useQuery({
        queryKey: ['contra-accounts', companyId],
        queryFn: async () => {
            const { data } = await axios.get(
                route('v2.voucher.admin.contra-accounts.get', companyId.value),
            );
            return data;
        },
        placeholderData: [],
        enabled: false,
    });

    return {
        contraAccounts,
        loadingContraAccounts,
        fetchContraAccounts,
    };
}
